// `/quiz` is the only address the product-recommendation quiz has: the live
// quiz is the fi-quizz modal, which has no URL of its own. So `/quiz` redirects
// to the PLP carrying `?openQuiz=1`, and the PLP opens the widget on mount
// (see fiQuiz.ts). Kept separate from fiQuiz.ts so the URL contract is
// unit-testable without React / GrowthBook.

export const QUIZ_AUTO_OPEN_PARAM = 'openQuiz';

const FALSEY_VALUES = new Set(['false', '0', 'no', 'off']);

/** True when the URL asks the page to open the quiz widget on arrival. */
export function hasQuizAutoOpenParam(search: string): boolean {
  const value = new URLSearchParams(search).get(QUIZ_AUTO_OPEN_PARAM);
  return value !== null && !FALSEY_VALUES.has(value.trim().toLowerCase());
}

function toSearchString(params: URLSearchParams): string {
  const value = params.toString();
  return value ? `?${value}` : '';
}

/**
 * Adds `openQuiz=1` while preserving every other param — the redirect must not
 * drop attribution (`utm_*`, `pc=`) or the `quizVariant` / `quizPdpPreview`
 * overrides a QA session is carrying.
 */
export function addQuizAutoOpenParam(search: string): string {
  const params = new URLSearchParams(search);
  params.set(QUIZ_AUTO_OPEN_PARAM, '1');
  return toSearchString(params);
}

/** Drops `openQuiz` once consumed, so a refresh doesn't reopen the quiz. */
export function removeQuizAutoOpenParam(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(QUIZ_AUTO_OPEN_PARAM);
  return toSearchString(params);
}
